export const PROFILE_ROUTES = {
	myProfile: "/app/me/profile",
	mySchedule: "/app/me/schedule",
} as const;
